import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { CoursesService } from "../services/courses.service";

@Injectable()
export class ModuleGuard implements CanActivate {

    constructor(private courses: CoursesService, private router: Router) { }

    // Return false if the user is not logged in
    canActivate() {
        return true;
        // const currentModule = this.courses.currentModule;
        // console.log(currentModule);
        // console.log(this.courses.currentCourse)
        // if (currentModule < this.courses.currentCourse.furthestModuleID) {
        //     return true;
        // } else {
        //     this.router.navigate(['/courses']);
        //     return false;
        // }
    }
}

